import React from "react";
import { StyledTableCell, StyledTableRow } from "customStyled";
import { Stack } from "@mui/material";

const InfinityUI = ({ content, isTableView, setLoaderRef }) => {
  if (!content) return null;

  if (isTableView) {
    return (
      <StyledTableRow ref={setLoaderRef} hover tabIndex={-1}>
        <StyledTableCell
          colSpan={100}
          sx={{ textAlign: "center", borderBottom: 0 }}
        >
          {content}
        </StyledTableCell>
      </StyledTableRow>
    );
  }

  return (
    <Stack
      ref={setLoaderRef}
      sx={{
        justifyContent: "center",
        alignItems: "center",
        minHeight: 32
      }}>
      {content}
    </Stack>
  );
};

export default React.memo(InfinityUI);
